// src/shared/components/protectedRoute.tsx
import { useRole } from '@/shared/utils/hooks/useRole'
import type { UserRoles } from '@/shared/utils/types/roles'
import { Navigate } from 'react-router-dom'

type ProtectedRouteProps = {
  children: React.ReactNode
  roles?: UserRoles[]
  anyRoles?: UserRoles[]
}

export const ProtectedRoute = ({ children, roles, anyRoles }: ProtectedRouteProps) => {
  const { hasAccess, hasAnyAccess } = useRole()

  const hasPermission = (!roles || hasAccess(roles)) && (!anyRoles || hasAnyAccess(anyRoles))

  if (!hasPermission) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
